import * as yup from 'yup';

export const numberSharesValidation = yup
  .number()
  .typeError('Antalet aktier måste vara ett nummer mellan 1 och 500')
  .max(500, 'Max antalet aktier är 500')
  .min(1, 'Antalet aktier måste vara fler än noll');
